export function Select({ className = "", children, ...props }) {
  return (
    <select
      className={`
        flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm
        text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed
        disabled:opacity-50 appearance-none cursor-pointer
        ${className}
      `}
      {...props}
    >
      {children}
    </select>
  )
}
